(() => {
  const boot = () => document.querySelectorAll('[data-pop1-returns-uploads]').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-return-files]');
    const status = root.querySelector('[data-return-status]');
    const errorBox = root.querySelector('[data-return-error]');
    const links = [...root.querySelectorAll('[data-return-link]')];
    const form = root.closest('form');
    const button = form?.querySelector('button[type="submit"]');
    const endpoint = root.dataset.endpoint;
    const maxBytes = 10 * 1024 * 1024;
    const allowed = new Set(['jpg','jpeg','png','webp','heic','heif']);
    let busy = false;

    const setError = message => { errorBox.textContent = message || ''; errorBox.hidden = !message; };
    const clearLinks = () => links.forEach(link => { link.value = ''; link.disabled = true; });
    const setBusy = value => {
      busy = value;
      if (button) { button.disabled = value; button.setAttribute('aria-busy', String(value)); }
    };
    const postJson = async payload => {
      const response = await fetch(endpoint, {
        method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(payload)
      });
      let data = {};
      try { data = await response.json(); } catch (_) {}
      if (!response.ok) throw new Error(data.error || data.message || `Upload service returned ${response.status}`);
      return data;
    };
    const uploadFile = (url, file) => new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('x-upsert', 'false');
      xhr.onload = () => (xhr.status >= 200 && xhr.status < 300)
        ? resolve() : reject(new Error(`Upload failed (${xhr.status}).`));
      xhr.onerror = () => reject(new Error('Photo upload failed. Please check your connection.'));
      const data = new FormData();
      data.append('cacheControl', '3600');
      data.append('', file);
      xhr.send(data);
    });
    input.addEventListener('change', async () => {
      if (busy) return;
      setError(''); clearLinks();
      const selected = [...input.files];
      if (!selected.length) { status.textContent = 'No photos selected.'; return; }
      if (selected.length > 3) {
        status.textContent = 'No photos uploaded.';
        setError('Please select no more than three photos.');
        input.value = ''; return;
      }
      for (const file of selected) {
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowed.has(extension)) {
          status.textContent = 'No photos uploaded.';
          setError('Please choose JPG, PNG, WebP or iPhone HEIC photos.');
          input.value = ''; return;
        }
        if (!file.size || file.size > maxBytes) {
          status.textContent = 'No photos uploaded.';
          setError('Each photo must be smaller than 10 MB.');
          input.value = ''; return;
        }
      }
      setBusy(true);
      let completed = 0;
      try {
        for (const [index, file] of selected.entries()) {
          status.textContent = `Uploading photo ${index + 1} of ${selected.length}…`;
          const signed = await postJson({action:'sign-upload',fileName:file.name,fileSize:file.size,contentType:file.type || 'application/octet-stream'});
          if (!signed.signedUrl || !signed.path) throw new Error('Could not prepare secure photo upload.');
          await uploadFile(signed.signedUrl, file);
          const finished = await postJson({action:'finalize',path:signed.path,fileName:file.name});
          if (!finished.downloadUrl) throw new Error('Could not create the private photo link.');
          links[index].value = finished.downloadUrl;
          links[index].disabled = false;
          completed++;
        }
        status.textContent = `${completed} photo${completed === 1 ? '' : 's'} attached. You can now submit your request.`;
      } catch (error) {
        // Retain successfully uploaded links, but never imply all selected photos were attached.
        status.textContent = completed
          ? `${completed} of ${selected.length} photos attached. You can try selecting your photos again.`
          : 'No photos attached yet.';
        setError(`${error.message || 'Upload failed.'} Please retry your photos before submitting.`);
      } finally { setBusy(false); }
    });
    form?.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); setError('Please wait until your photos finish uploading.'); root.scrollIntoView({block:'center'}); }
      links.forEach(link => { link.disabled = !link.value; });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
